import { createSlice } from '@reduxjs/toolkit';
import { ZasilkovnaStateType } from 'src/types/zasilkovna';
import { formatDataCarriers, formatDataCarriersAddress } from './functions';

const initialState: ZasilkovnaStateType = {
    loading: false,
    data: null,
    dataCarriers: null,
    dataCarriersRaw: null,
    dataCarriersAddress: null,
    error: false,
};
export const zasilkovnaSlice = createSlice({
    name: 'zasilkovna',
    initialState,
    reducers: {
        getZasilkovnaFetch: (state, _action) => {
            state.loading = true;
            state.error = false;
        },
        getZasilkovnaFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getZasilkovnaFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        getZasilkovnaCarriersListFetch: (state) => {
            state.loading = true;
            state.error = false;
        },
        getZasilkovnaCarriersFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getZasilkovnaCarriersFetchSuccess: (state, action) => {
            // Update carriers only if provided (from carriers list fetch)
            if (action.payload.carriers && action.payload.carriers.length > 0) {
                state.dataCarriers = formatDataCarriers(action.payload.carriers);
                state.dataCarriersRaw = action.payload.carriers;
            }
            // Update addresses (merge with existing)
            if (action.payload.addresses && action.payload.addresses.length > 0) {
                const newAddresses = formatDataCarriersAddress(action.payload.addresses);
                state.dataCarriersAddress = {
                    ...state.dataCarriersAddress,
                    ...newAddresses,
                };
            }
            state.loading = false;
        },
        getZasilkovnaCarriersFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
    },
});

export const {
    getZasilkovnaFetch,
    getZasilkovnaFetchSuccess,
    getZasilkovnaFetchFailure,
    getZasilkovnaCarriersListFetch,
    getZasilkovnaCarriersFetch,
    getZasilkovnaCarriersFetchSuccess,
    getZasilkovnaCarriersFetchFailure,
} = zasilkovnaSlice.actions;

export default zasilkovnaSlice.reducer;
